import { useEffect, useState } from 'react';

// Detect underpowered devices that should skip expensive visual effects
// (animated `filter: blur()`, `backdrop-filter`, requestAnimationFrame loops).
// Used by the aurora background and login page so weak hardware (e.g. base-spec
// Dell Optiplexes with Intel iGPUs) doesn't melt under decorative animation.
export function detectLowPower(): boolean {
  if (typeof window === 'undefined') return true;
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return true;
  const nav = navigator as Navigator & { deviceMemory?: number };
  if (typeof nav.hardwareConcurrency === 'number' && nav.hardwareConcurrency < 4) return true;
  if (typeof nav.deviceMemory === 'number' && nav.deviceMemory < 4) return true;
  return false;
}

export function useLowPower(): boolean {
  const [lowPower, setLowPower] = useState<boolean>(() => detectLowPower());

  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (!mq) return;
    const handler = () => setLowPower(detectLowPower());
    mq.addEventListener?.('change', handler);
    return () => mq.removeEventListener?.('change', handler);
  }, []);

  return lowPower;
}
